/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Assistant_Saved_Prompt_Remove_FailedInputs */



/**
* | output |
* | --- |
* | "Couldn't remove the prompt. Check your connection and try again." |
*
* @param {Assistant_Saved_Prompt_Remove_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const assistant_saved_prompt_remove_failed = /** @type {((inputs?: Assistant_Saved_Prompt_Remove_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assistant_Saved_Prompt_Remove_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Impossible de supprimer l'invite. Vérifiez votre connexion et réessayez.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Eingabeaufforderung konnte nicht entfernt werden. Prüfen Sie Ihre Verbindung und versuchen Sie es erneut.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impossibile rimuovere il prompt. Controlla la connessione e riprova.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Не удалось удалить запрос. Проверьте подключение и повторите попытку.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se pudo eliminar la solicitud. Comprueba tu conexión e inténtalo de nuevo.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("无法删除提示。请检查网络连接后重试。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プロンプトを削除できませんでした。接続を確認して、もう一度お試しください。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रॉम्प्ट हटाया नहीं जा सका। अपना कनेक्शन जाँचें और फिर से प्रयास करें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Não foi possível remover o prompt. Verifique a ligação e tente novamente.")
	return /** @type {LocalizedString} */ ("Couldn't remove the prompt. Check your connection and try again.")
});